import InfoIcon from 'js/components/recipeBuilder/icons/InfoIcon';
import { IconButton } from 'new/elements/IconButton/IconButton';
import React from 'react';
import { Switch } from 'new/elements/Switch';
import { MarkdownContent } from 'new/elements/MarkdownContent';
import Tooltip, { DefaultTooltipPopperProps } from 'js/components/elements/mui/Tooltip';
import { useAsyncTransformControl } from 'js/components/recipeBuilder/AsyncTransformControl/useAsyncTransformControl';

import s from './AsyncTransformControl.module.scss';

export function AsyncTransformControl() {
  const { isAsync, disableAsyncMode, toggleAsync } = useAsyncTransformControl();
  if (disableAsyncMode) return null;
  return <AsyncTransformControlUI isAsync={isAsync} toggleAsync={toggleAsync} />;
}

const AsyncTransformControlUI = React.memo(
  ({ isAsync, toggleAsync }: any) => {
    return (
      <div className={s.container}>
        <label htmlFor="async-transform-checkbox">Process records in parallel</label>
        <Switch id="async-transform-checkbox" checked={isAsync} onChange={toggleAsync} />

        <Tooltip
          // @ts-ignore
          interactive="true"
          placement="bottom"
          tooltipTheme="fieldInfo"
          PopperPros={DefaultTooltipPopperProps}
          title={
            <MarkdownContent>
              Enable this option to transform each record asynchronously, allowing multiple records
              to be processed at the same time. This is especially useful when transformations
              involve external API calls.
            </MarkdownContent>
          }
          children={
            <IconButton>
              <InfoIcon />
            </IconButton>
          }
        />
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.isAsync === nextProps.isAsync && prevProps.toggleAsync === nextProps.toggleAsync,
);
